import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_SETTINGS_DEFAULTS } from '../../siteSettingsDefaults';
import { HOME_COPY_DEFAULTS } from '../../content/pageCopyDefaults';
import { brandNameFromSettings } from '../../siteBrand';

/** Centered brand story — Shopify rich-text style, no image column. */
export default function HomeAboutSection({ site, homeCopy = {} }) {
  const brandName = brandNameFromSettings(site);
  const title = site.home_about_title || SITE_SETTINGS_DEFAULTS.home_about_title;
  const text = site.home_about_text || SITE_SETTINGS_DEFAULTS.home_about_text;
  const tagline = site.home_about_tagline || SITE_SETTINGS_DEFAULTS.home_about_tagline;
  const ctaLabel = homeCopy.about_cta_label || HOME_COPY_DEFAULTS.about_cta_label;
  const ctaUrl = homeCopy.about_cta_url || HOME_COPY_DEFAULTS.about_cta_url;

  return (
    <section className="home-about-quote" aria-labelledby="home-about-title">
      <div className="container store-page__container">
        <div className="home-about-quote__inner">
          <p className="home-about-quote__eyebrow">{brandName}</p>
          <h2 id="home-about-title" className="home-about-quote__title">
            {title}
          </h2>
          <p className="home-about-quote__text">{text}</p>
          {tagline ? (
            <p className="home-about-quote__tagline">&ldquo;{tagline}&rdquo;</p>
          ) : null}
          <Link to={ctaUrl} className="btn btn-primary home-about-quote__cta">
            {ctaLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
